<template>
	<div class="horse-menu-mobile d-md-none">
		<div class="menu-header">
			<h2 class="menu-title text-truncate mb-0">{{ title }}</h2>
			<a href="#" class="menu-icon" @click.prevent="$emit('close')">
				<font-awesome-icon :icon="['fal', 'times']" />
			</a>
		</div>
		<div class="menu-content">
			<section class="menu-section">
				<hr class="menu-separator" />
				<MenuTabsMobile :swiper_tabs="swiper_tabs" :action="action" @close="$emit('close')" />
			</section>
		</div>
	</div>
</template>

<script type="text/javascript">
	export default {
		name: 'PageMenuMobile',
		props: {
			title: { type: String, default: '' },
			swiper_tabs: { type: Array, default: () => [] },
			action: { type: Function, default: null } /* Callback des onglets pilotés par action (cf. prop swiper_action du HeaderTab) */
		},
		components: {
			MenuTabsMobile: () => import('@/components/MenuTabsMobile')
		}
	}
</script>
